module.exports = __webpack_public_path__ + "img/ConcurrencyCriticalSection.563855b3.gif";